import React, { useState ,useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles';
import ChartLogin from './chart/ChartLogin';
import { Typography, Grid, Box, Button, Divider } from '@material-ui/core';
import CircleIcon from '@mui/icons-material/Circle';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import NativeSelect from '@mui/material/NativeSelect';

const useStyles = makeStyles((theme) => ({
  divider : {
    display: 'flex',

    [theme.breakpoints.down("sm")]: {
      display: 'none'
    },
  },
  date : {
    fontSize: '12px',
    color: '#ababab',
    position: 'absolute', 
    bottom: '15px', 
    right: '0',

    [theme.breakpoints.down("sm")]: {
      bottom: '-20px !important', 
      right: '0 !important',
      left: '0',
      textAlign: 'center'
    },
  }
}));

const ReportChartLogin = ({ timeFrameSelected, chartData }) => {
  const dispatch = useDispatch()
  const classes = useStyles();
  const {id} = useParams()
  const [series, setSeries] = useState([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    const colors = ["#fc030b", "#247BA0", "#2d2e2e", "#009200", "#fbff03"]
    if (chartData?.seriesByCategory) {
      let counter = 0;
      chartData.seriesByCategory?.forEach(el => {
        const sumCategory = el.data.reduce((p, c) => p + c, 0)
        counter = counter + sumCategory
      });
      setTotal(counter)
    }
    chartData.seriesByCategory?.forEach((el,i) => {
      el.color = colors[i]
    })
    setSeries(chartData?.seriesByCategory)
  },[chartData])

  const handleTimeFrame = (e) => {
    timeFrameSelected(e.target.value)
  }

  return (
    <Grid container>
      <Box className="d-flex mb-15 w-100" style={{ justifyContent: 'space-between' }}>
        <Typography className="font-size-18 bold">
          Login Chart
        </Typography>
        <div className="d-flex" >
          <FormControl fullWidth className="mr-5">
            <InputLabel variant="standard" htmlFor="uncontrolled-native">
              Timeframe
            </InputLabel>
            <NativeSelect
              defaultValue={'daily'}
              inputProps={{
                name: 'age',
                id: 'uncontrolled-native',
              }}
              onChange={handleTimeFrame}
            >
              <option value={'daily'}>Daily</option>
              <option value={'monthly'}>Monthly</option>
              <option value={'last7days'}>Last 7 days</option>
            </NativeSelect>
          </FormControl>
          <Button
          variant="contained"
          color="secondary"
          className="btn-black text-transform-unset"
          style={{padding: "5px 10px"}}
          >
          Export
          </Button>          
        </div>
      </Box>
      <Grid item xs={12} md={7}>
        <ChartLogin chartData={chartData}/>
      </Grid>
      <Grid item xs={12} md={1} className={classes.divider} style={{justifyContent: 'center'}}>
        <img className='pl-5' src="/stroke-divider.png" style={{width: '8px', height: '300px'}}/>
      </Grid>
      <Grid item xs={12} md={4} style={{position: 'relative'}}>
        <table width='100%'>

          <tr>
            <td width='80%'>
              <Typography className='font-size-16 reguler'>
                Login
              </Typography>
            </td>
            <td>
              <Typography className='text-right font-size-16 reguler'>
                Jumlah
              </Typography>
            </td>
          </tr>
          {
            series?.length !==0 ?
            series?.map(seri => {
              return (
                <tr key={seri.name}>
                <td width='80%' style={{padding: '5px 0'}}>
                  <Typography className='font-size-14 d-flex' style={{alignItems: 'center'}}>
                    <CircleIcon className='font-size-14' style={{color: seri.color}}/>&ensp; {seri.name}
                  </Typography>
                </td>
                <td>
                  <Typography className='text-right font-size-14'>
                    {seri.data?.reduce((p, c) => p + c, 0)}
                  </Typography>
                </td>
              </tr>
              )
            })
          :
          <div>Loading</div>
        }
        <tr>
          <td width='80%'>
            <Typography className='font-size-16 reguler'>
              Total
            </Typography>
          </td>
          <td>
          <Typography className='text-right font-size-16 reguler'>
            {total}
          </Typography>
          </td>
        </tr>
        </table>
        <Typography className={classes.date}>
          10/10/2021 - 11/10/2021
        </Typography>
      </Grid>
    </Grid>
  );
}

export default ReportChartLogin
